// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../ProductSelectOption";
import { encodeJson as encodeJson_2, decodeJson as decodeJson_2, encodeBinary as encodeBinary_2, decodeBinary as decodeBinary_2, } from "../../../inside/payment/PaymentProvider";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { WireType, } from "../../../../runtime/wire/index";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, unpackFns, } from "../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        productOptions: [],
        paymentProvider: undefined,
        issuedCouponIds: [],
        productDuration: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    var _a;
    const result = {};
    result.productOptions = value.productOptions.map(value => encodeJson_1(value));
    if (value.paymentProvider !== undefined)
        result.paymentProvider = encodeJson_2(value.paymentProvider);
    result.issuedCouponIds = value.issuedCouponIds.map(value => tsValueToJsonValueFns.int64(value));
    switch ((_a = value.productDuration) === null || _a === void 0 ? void 0 : _a.field) {
        case "productDays": {
            result.productDays = tsValueToJsonValueFns.int64(value.productDuration.value);
            break;
        }
        case "productMonths": {
            result.productMonths = tsValueToJsonValueFns.int64(value.productDuration.value);
            break;
        }
    }
    return result;
}
export function decodeJson(value) {
    var _a, _b, _c, _d;
    const result = getDefaultValue();
    result.productOptions = (_b = (_a = value.productOptions) === null || _a === void 0 ? void 0 : _a.map((value) => decodeJson_1(value))) !== null && _b !== void 0 ? _b : [];
    if (value.paymentProvider !== undefined)
        result.paymentProvider = decodeJson_2(value.paymentProvider);
    result.issuedCouponIds = (_d = (_c = value.issuedCouponIds) === null || _c === void 0 ? void 0 : _c.map((value) => jsonValueToTsValueFns.int64(value))) !== null && _d !== void 0 ? _d : [];
    if (value.productDays !== undefined)
        result.productDuration = { field: "productDays", value: jsonValueToTsValueFns.int64(value.productDays) };
    if (value.productMonths !== undefined)
        result.productDuration = { field: "productMonths", value: jsonValueToTsValueFns.int64(value.productMonths) };
    return result;
}
export function encodeBinary(value) {
    var _a;
    const result = [];
    for (const tsValue of value.productOptions) {
        result.push([2, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.paymentProvider !== undefined) {
        const tsValue = value.paymentProvider;
        result.push([3, { type: WireType.LengthDelimited, value: encodeBinary_2(tsValue) }]);
    }
    for (const tsValue of value.issuedCouponIds) {
        result.push([4, tsValueToWireValueFns.int64(tsValue)]);
    }
    switch ((_a = value.productDuration) === null || _a === void 0 ? void 0 : _a.field) {
        case "productDays": {
            const tsValue = value.productDuration.value;
            result.push([1, tsValueToWireValueFns.int64(tsValue)]);
            break;
        }
        case "productMonths": {
            const tsValue = value.productDuration.value;
            result.push([5, tsValueToWireValueFns.int64(tsValue)]);
            break;
        }
    }
    return serialize(result);
}
const oneofFieldNumbersMap = {
    productDuration: new Set([1, 5]),
};
const oneofFieldNamesMap = {
    productDuration: new Map([
        [1, "productDays"],
        [5, "productMonths"],
    ]),
};
export function decodeBinary(binary) {
    var _a;
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    const wireFieldNumbers = Array.from(wireFields.keys()).reverse();
    collection: {
        const wireValues = wireMessage.filter(([fieldNumber]) => fieldNumber === 2).map(([, wireValue]) => wireValue);
        const value = wireValues.map((wireValue) => wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined).filter(x => x !== undefined);
        if (!value.length)
            break collection;
        result.productOptions = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_2(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.paymentProvider = value;
    }
    collection: {
        const wireValues = wireMessage.filter(([fieldNumber]) => fieldNumber === 4).map(([, wireValue]) => wireValue);
        const value = Array.from(unpackFns.int64(wireValues));
        if (!value.length)
            break collection;
        result.issuedCouponIds = value;
    }
    oneof: {
        const oneofFieldNumbers = oneofFieldNumbersMap.productDuration;
        const oneofFieldNames = oneofFieldNamesMap.productDuration;
        const fieldNumber = wireFieldNumbers.find(v => oneofFieldNumbers.has(v));
        if (fieldNumber == null)
            break oneof;
        const wireValue = wireFields.get(fieldNumber);
        const wireValueToTsValueMap = {
            [1](wireValue) { return wireValueToTsValueFns.int64(wireValue); },
            [5](wireValue) { return wireValueToTsValueFns.int64(wireValue); },
        };
        const value = (_a = wireValueToTsValueMap[fieldNumber]) === null || _a === void 0 ? void 0 : _a.call(wireValueToTsValueMap, wireValue);
        if (value === undefined)
            break oneof;
        result.productDuration = { field: oneofFieldNames.get(fieldNumber), value: value };
    }
    return result;
}
